module.exports = __webpack_public_path__ + "static/media/add_team_member.a8dcede6.svg";